<template>
    <div class="accordion-panel castle-stone-0" :class="props.type" :id="props.id">
        <div
            v-if="!props.type"
            class="cta d-flex align-items-center justify-content-between pa-4"
            :class="{ active: active }"
            @click="toggleBellows()"
        >
            <p class="geist-font semi-bold large">{{ props.label }}</p>
            <font-awesome-icon class="expand-arrow" icon="fa-solid fa-chevron-down" size="lg" />
        </div>
        <div
            v-else
            class="cta d-flex align-items-center justify-content-between pa-4"
            :class="{ active: active }"
            @click="toggleBellows()"
        >
            <div class="left d-flex align-items-center">
                <font-awesome-icon class="gold--text mr-3" icon="fa-solid fa-sparkles" size="lg" />
                <p class="geist-font semi-bold pt-1 tavern-ale-40--text">{{ props.label }}</p>
            </div>
            <font-awesome-icon
                class="expand-arrow tavern-ale-40--text"
                icon="fa-solid fa-chevron-down"
            />
        </div>
        <div class="bellow px-4 mt-n4 pb-4" :class="{ active: active }">
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
import { type } from '@amcharts/amcharts5'
import { ref, watch, computed } from 'vue'

const props = defineProps({
    label: {
        type: String,
        default: '',
    },
    id: {
        type: String,
        default: '',
    },
    initiallyExpanded: {
        type: Boolean,
        default: false,
    },
    type: {
        type: String,
        default: '',
    },
})

const active = ref(props.initiallyExpanded)

const toggleBellows = () => {
    active.value = !active.value
}
</script>

<style scoped lang="scss">
@forward '@/styles/new_styles.scss';

.accordion-panel {
    border-radius: 8px;
    min-height: 54px;

    &.ai-summary {
        background: linear-gradient(
            20deg,
            rgba(255, 255, 255, 1) 30%,
            rgba(242, 175, 58, 0.3) 100%
        );

        .cta {
            border-left: 5px solid vars.$gold;
            border-radius: 0 8px 8px 0;
        }

        .bellow {
            border-left: 5px solid;
            border-image: linear-gradient(to bottom, vars.$gold, #8c6522) 0 0 0 1;
        }
    }

    .cta {
        cursor: pointer;
        border-radius: 8px;

        .expand-arrow {
            transition: all 0.3s ease-in-out;
        }
        &.active {
            margin-bottom: 16px;

            .expand-arrow {
                transform: rotate(180deg);
            }
        }
    }

    .bellow {
        max-height: 0;
        overflow: hidden;
        opacity: 0;
        transition: all 0.3s ease-in-out;

        &.active {
            max-height: none; /* Remove the fixed height limit */
            overflow: visible; /* Allow content to be fully visible */
            opacity: 1;
        }
    }
}
</style>
